import { OnDemand } from '@/helpers/onDemand'

const COOKIE_NAME = 'tap_rc'
export default (ctx, inject) => {
  const loader = new OnDemand(
    'https://script.tapfiliate.com/tapfiliate.js',
    null,
    true
  )

  inject('tapfiliate', {

    init (that) {
      loader.load(() => {
        (function (t, a, p) {
          t.TapfiliateObject = a
          t[a] = t[a] || function () {
            (t[a].q = t[a].q || []).push(arguments)
          }
        })(window, 'tap')

        window.tap('create', '39621-7503be', { integration: 'javascript' })

        if (that.$route.query.ref) {
          that.$cookies.set(COOKIE_NAME, that.$route.query.ref, {
            path: '/',
            maxAge: 60 * 60 * 24 * 30
          })
        }

        window.tap('detect')
        that.$root.$emit('tapfiliate_loaded', true)
      })
    },

    customer (that, customerId, email) {
      window.tap('customer', customerId, {
        meta_data: {
          email
        }
      })
    },

    _submit (commissionType, externalId, customerId) {
      window.tap('conversion', externalId, 0, { customer_id: customerId }, commissionType)
    },

    async adSubmitted (that, productId, customerId, productType) {
      const externalId = productType + '-submitted-' + productId

      this._submit(productType + '-submitted', externalId, customerId)
      const referralCode = that.$cookies.get(COOKIE_NAME)
      if (referralCode) {
        try {
          await that.$axios.put(`/private/product/tapfiliate/${productId}?referral_code=${referralCode}`, {})
        } catch (e) {
        }
      }
    },

    async motorhomeSubmitted (that, productId, customerId) {
      const externalId = 'motorhome-submitted-' + productId

      this._submit('motorhome-submitted', externalId, customerId)
      const referralCode = that.$cookies.get(COOKIE_NAME)
      if (referralCode) {
        try {
          await that.$axios.put(`/private/product/tapfiliate/${productId}?referral_code=${referralCode}`, {})
        } catch (e) {
        }
      }
    },

    async trailerSubmitted (that, productId, customerId) {
      const externalId = 'trailer-submitted-' + productId
      this._submit('trailer-submitted', externalId, customerId)
      const referralCode = that.$cookies.get(COOKIE_NAME)
      if (referralCode) {
        try {
          await that.$axios.put(`/private/product/tapfiliate/${productId}?referral_code=${referralCode}`, {})
        } catch (e) {
        }
      }
    }

  })
}
